<template>
  <div class="circular-detail">
    <div
      v-if="error"
      class="error"
    >
      {{ error }}
    </div>
    <div
      v-if="myData"
      class="post"
    >
      <h3>{{ myData.title }}</h3>
      <p class="pre">
        {{ myData.summary }}
      </p>
      <button @click="doDownload">Download</button>
      <button
        v-if="role === 'testAdmin'"
        class="delete"
        @click="handleClick"
      >
        delete bulletin
      </button>
    </div>
  </div>
</template>

<script>
import { db, doc, deleteDoc, ref, deleteObject, storage } from '@/firebase/config'
import { useRouter } from 'vue-router'
import getPost from '@/composables/getPost'
import getUser from '@/composables/getUser'
import useDownload from '@/composables/useDownload'
import { reactive, toRefs, watchEffect } from '@vue/runtime-core'
export default {
  props: ['id'],
  setup (props) {
    const { myData, error, load } = getPost()
    const router = useRouter()
    const { user, role } = getUser()
    const { downloadFile } = useDownload()
    const data = reactive({
      bulletin: null
    })
    const { bulletin } = toRefs(data)

    load(props.id, 'circulars')

    const handleClick = async () => {
      // Create a reference to the file to delete
      const storedRef = ref(storage, `/schools/inspire-schools/circulars/${bulletin.value.name}`)
      await deleteObject(storedRef)
      await deleteDoc(doc(db, '/schools/inspire-schools/circulars', bulletin.value.id))
      router.push('/circulars')
    }

    const doDownload = () => {
      downloadFile(myData.value.URL, `${bulletin.value.name}`)
    }
    watchEffect(() => {
      bulletin.value = myData.value ? myData.value : null
    })
    return { myData, error, handleClick, user, role, doDownload }
  }
}
</script>

<style>
.circular-detail {
  max-width: 960px;
  color: whitesmoke;
  margin: 0 auto;
  padding-top: 20px;
}
.circular-detail h3 {
  color: #276749;
  font-size: 2.3em;
}
.circular-detail a {
  text-decoration: none;
  color: whitesmoke;
}
.post {
  padding: 10px;
  background: #333;
}

.pre {
    margin: 5px auto;
    padding: 15px;
    font-size: 1.6em;
    width: 90%;
  }
</style>
